export enum EventGeneralFormFieldEnum {
    TITLE = 'title',
    START_DATE = 'startDate',
    END_DATE = 'endDate',
    CUSTOMER = 'customer',
    CONTACT_PERSON = 'contact',
    DESCRIPTION = 'description',
    RESOURCE = 'resource',
    STATUS = 'status'
}